var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_17202)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0699 7.59667C14.1667 7.6934 14.2434 7.80824 14.2958 7.93464C14.3481 8.06104 14.3751 8.19652 14.3751 8.33333C14.3751 8.47015 14.3481 8.60563 14.2958 8.73203C14.2434 8.85842 14.1667 8.97327 14.0699 9.07L9.99989 13.14L5.92989 9.07C5.73452 8.87462 5.62476 8.60964 5.62476 8.33333C5.62476 8.19652 5.6517 8.06105 5.70406 7.93465C5.75641 7.80826 5.83315 7.69341 5.92989 7.59667C6.02663 7.49993 6.14148 7.42319 6.26788 7.37083C6.39428 7.31848 6.52975 7.29153 6.66656 7.29153C6.94286 7.29153 7.20785 7.40129 7.40323 7.59667L9.99989 10.1933L12.5966 7.59667C12.6933 7.49991 12.8081 7.42316 12.9345 7.37079C13.0609 7.31843 13.1964 7.29147 13.3332 7.29147C13.47 7.29147 13.6055 7.31843 13.7319 7.37079C13.8583 7.42316 13.9732 7.49991 14.0699 7.59667Z",
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_17202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.687c70fcf173f564f3b7f8d73b2b0318.svg";
export { ForwardRef as ReactComponent };